export function convertUTCDateToLocalDateString(utcDateString: string | undefined): string {
  if (!utcDateString)
    return '???';
  const utcDate = new Date(utcDateString);
  const localDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000); // Convert UTC to local date
  const day = String(localDate.getDate()).padStart(2, '0');
  const month = String(localDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based
  const year = localDate.getFullYear();
  return `${day}.${month}.${year}`;
}